type TablePagination = {
  persistedPageSize: number;
  persistedPage: number;
  persistedSkip: number;
};

const PAGE_KEY = (domain: string) => `${domain}_table_page`;
const PAGE_SIZE_KEY = (domain: string) => `${domain}_table_page_size`;

const safeNumber = (value: string | null, fallback: number) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

export const getTablePaginationFromStorage = (
  domain: string,
  fallbackPageSize: number = 10,
  fallbackPage: number = 1,
): TablePagination => {
  const persistedPageSize = safeNumber(
    localStorage.getItem(PAGE_SIZE_KEY(domain)),
    fallbackPageSize,
  );

  const persistedPage = safeNumber(localStorage.getItem(PAGE_KEY(domain)), fallbackPage);

  const persistedSkip = (persistedPage - 1) * persistedPageSize;

  return {
    persistedPageSize,
    persistedPage,
    persistedSkip,
  };
};

export const setTablePageStorage = (domain: string, page: number) => {
  localStorage.setItem(PAGE_KEY(domain), String(page));
};

export const setTablePageSizeStorage = (domain: string, pageSize: number) => {
  localStorage.setItem(PAGE_SIZE_KEY(domain), String(pageSize));
};
